import { useEffect, useState } from "react";
import Modal from "../../componants/modal/Modal";
import service from "../../services/service";
import endpoints from "../../services/endpoints";
import "./AccountSetup.css";

const AvatarModal = ({ open, selected, onApply, onClose }) => {
  const [search, setSearch] = useState("");
  const [pending, setPending] = useState(selected || null);
  const [avatars, setAvatars] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setPending(selected || null);
    setSearch("");
    setLoading(true);
    service
      .get(endpoints.users.avatars, {}, { silent: true })
      .then(({ data }) => setAvatars(data.data || []))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sync selected only when modal opens
  }, [open]);

  const filtered = avatars.filter((avatar) =>
    avatar.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Modal open={open} onClose={onClose} maxWidth={560} className="avatarModal">
      <h2 className="avatarModal__title">Choose Avatar</h2>
      <p className="avatarModal__subtitle">Select your profile avatar</p>

      <div className="avatarModal__search">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="7" cy="7" r="5.5" stroke="#9CA3AF" strokeWidth="1.3" />
          <path d="M11 11l3.5 3.5" stroke="#9CA3AF" strokeWidth="1.3" strokeLinecap="round" />
        </svg>
        <input
          type="text"
          placeholder="Search Avatar"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="avatarModal__previewRow">
        {pending?.image ? (
          <img className="avatarModal__previewCircle" src={pending.image} alt="" />
        ) : (
          <span className="avatarModal__previewCircle" style={{ background: "#E5E7EB" }} />
        )}
      </div>

      <div className="avatarModal__grid">
        {loading && <p className="avatarModal__empty">Loading avatars...</p>}
        {!loading && filtered.length === 0 && <p className="avatarModal__empty">No avatars found.</p>}
        {filtered.map((avatar) => (
          <button
            key={avatar.id}
            type="button"
            className={
              pending?.id === avatar.id
                ? "avatarModal__item avatarModal__item--selected"
                : "avatarModal__item"
            }
            onClick={() => setPending(avatar)}
            aria-label={avatar.name}
          >
            <img src={avatar.image} alt="" />
            {pending?.id === avatar.id && (
              <span className="avatarModal__check">
                <svg width="12" height="12" viewBox="0 0 20 20" fill="none">
                  <circle cx="10" cy="10" r="10" fill="#21B389" />
                  <path
                    d="M6 10.2l2.4 2.4L14 7.2"
                    stroke="#fff"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            )}
          </button>
        ))}
      </div>

      <button
        type="button"
        className="accountSetup__submit avatarModal__apply"
        disabled={!pending}
        onClick={() => onApply(pending)}
      >
        Apply Avatar
      </button>
      <button type="button" className="accountSetup__skipLink" onClick={onClose}>
        Skip for Now
      </button>
    </Modal>
  );
};

export default AvatarModal;
